export default {
  teamMember: {
    searchWarning: 'The value is greater than 8 characters. The content will be shortened.',
  },
};
